// `pie` is a short keyword that can show up inside other diagrams, so only treat the
// chart as a pie when it is the first meaningful line.
const PIE_HEADER = /^(?:\s*(?:%%.*)?\n)*\s*pie\b/;
// `"Label" : 88`, `"Label" "88"`, `"Label": "$1,200"` — the colon is optional because
// LLMs often drop it and quote the value instead.
const QUOTED_SLICE_LINE = /^(\s*)"([^"]*)"\s*:?\s*(.+)$/;
// `Label: 88` — split on the last colon so a label containing one ("Store: North") survives.
const BARE_SLICE_LINE = /^(\s*)(.+)\s*:\s*([^:]+)$/;

/** @param {string} raw */
function parseValue(raw) {
  const cleaned = raw.trim().replace(/^"(.*)"$/, '$1').replace(/[$%,\s]/g, '');
  const value = Number(cleaned);
  return cleaned && Number.isFinite(value) ? value : undefined;
}

/**
 * @param {string} chart
 * @returns {string}
 */
export function normalizePieChart(chart) {
  if (!PIE_HEADER.test(chart)) return chart;

  return chart
    .split('\n')
    .map((line) => {
      const trimmed = line.trim();
      if (!trimmed || trimmed.startsWith('%%') || /^(pie|title|accTitle|accDescr)\b/.test(trimmed)) {
        return line;
      }

      const slice = line.match(QUOTED_SLICE_LINE) ?? line.match(BARE_SLICE_LINE);
      if (!slice) return line;

      const [, indent, label, rawValue] = slice;
      const value = parseValue(rawValue);
      if (value === undefined) return line;

      const name = label.trim().replace(/"/g, "'");
      return `${indent}"${name}" : ${value}`;
    })
    .join('\n');
}
